module.exports = __webpack_public_path__ + "static/img/sc2.0852e0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/202104sc/sc2.png
// module id = Wjxa
// module chunks = 0